export const ACTION = { 
    CREATE: "CREATE",
    VIEW: "VIEW",
    UPDATE: "UPDATE"
}